export class ActionResult {
  public success = false;
  public message = "";
}
